export default [
  {
    path: "/",
    component: () => import("../pages/www/Layout"),
    children: [
      {
        path: "/",
        name: "home",
        component: () => import("../pages/www/Home")
      },
      {
        path: "type/:id",
        name: "type",
        component: () => import("../pages/www/Type")
      },
      {
        path: "article/:id",
        name: "articleDetail",
        component: () => import("../pages/www/Detail")
      }
    ]
  }
];
